import Component from '@bythepixel/component-loader';
import Swiper, {
  Pagination, Navigation, Autoplay, Mousewheel, EffectFade,
} from 'swiper';

Swiper.use([Pagination, Navigation, Autoplay, Mousewheel, EffectFade]);

export default class SwiperSlider extends Component {
  static loaderPriority = 'in-view'
  constructor(sliderEl, swiperOptions) {
    super(sliderEl, swiperOptions);
    this.Swiper = Swiper;
  }
}
